import { ResetPasswordScreen } from "features/auth/ResetPassword";
import { ResetPasswordErrorScreen } from "features/auth/ResetPasswordError";
import { ResetPasswordInstructionsSentScreen } from "features/auth/ResetPasswordInstructionsSent";
import { SignInScreen } from "features/auth/SignIn";
import { UpdatePasswordScreen } from "features/auth/UpdatePassword";
import { Redirect, Route, Switch } from "react-router-dom";

import { NAVIGATOR } from "../index";

export const AuthNavigator = () => {
  return (
    <Switch>
      <Route exact path={NAVIGATOR.signIn} component={SignInScreen} />
      <Route
        exact
        path={NAVIGATOR.updatePassword}
        component={UpdatePasswordScreen}
      />
      <Route
        exact
        path={NAVIGATOR.resetPassword}
        component={ResetPasswordScreen}
      />
      <Route
        exact
        path={NAVIGATOR.resetPasswordInstructionsSent}
        component={ResetPasswordInstructionsSentScreen}
      />
      <Route
        exact
        path={NAVIGATOR.resetPasswordError}
        component={ResetPasswordErrorScreen}
      />
      <Route path="*">
        <Redirect to={NAVIGATOR.signIn} />
      </Route>
    </Switch>
  );
};
